import { html, type TemplateResult } from 'lit';

import type { Variant } from '../types/booking-request.types.js';
import { variantRegistry } from './variants.js';

interface BookingRequestFormTemplateParams {
    adultPaxCount: number;
    childrenPaxCount: number;
    emailPattern: string;
    endDateLabel: string;
    formName: string;
    hasOwningTeam: boolean;
    hasTripInfo: boolean;
    isSubmitting: boolean;
    lang: string;
    namePattern: string;
    newsletter: string;
    priceLabel: string;
    startDateLabel: string;
    supportPhone: string;
    tripTitle: string;
    variant: Variant;
    missingInternalValueError: boolean;
    onAdultCounterChange: (event: CustomEvent<{ count: number }>) => void;
    onChildrenCounterChange: (event: CustomEvent<{ count: number }>) => void;
    onSalesSiteSelected: (event: CustomEvent) => void;
    onSubmit: (event: SubmitEvent) => void;
}

export const renderBookingRequestFormTemplate = ({
    variant,
    ...rest
}: BookingRequestFormTemplateParams): TemplateResult => {
    const renderFn = variantRegistry[variant] || variantRegistry['default'];

    return html` ${renderFn(rest)} `;
};
